import axios from '@/plugins/axios';

const initialState = {
  list: [],
};

const actions = {
  async fetchList({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('users/notifications', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const parsedList = data.data.tasks.map((item) => ({
        ...item,
        data: JSON.parse(item.data),
      }));

      commit('setList', parsedList);

      return data;
    } catch (error) {
      return error;
    }
  },

  async sendViewedNotifications({ dispatch }, taskIds) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      dispatch('updateViewedNotifications', taskIds);

      await axios.put(
        'users/notifications/viewed',
        { taskIds },
        {
          headers: { Authorization: `Bearer ${token}`, Lang: lang },
        },
      );

      return { success: true };
    } catch (error) {
      return error;
    }
  },

  updateViewedNotifications({ state, commit }, taskIds) {
    const list = state.list.map((item) => {
      const itemCopy = { ...item, data: { ...item.data } };

      if (taskIds.includes(itemCopy.id)) {
        itemCopy.is_viewed = 1;
      }

      return itemCopy;
    });

    commit('setList', list);
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
